var _defs, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 620,
    viewBox: "0 0 360 620",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gbw",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#434343"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 620,
    fill: "url(#gbw)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 620,
    fill: "rgba(255,255,255,0.15)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 0,
    width: 180,
    height: 620,
    fill: "rgba(255,255,255,0.1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackwhite);
export default __webpack_public_path__ + "static/media/blackwhite.12333199f80010572aaceb8436274786.svg";
export { ForwardRef as ReactComponent };